export const AboutUsPageTranslationsUk = {
  'About us': 'Про нас',
};
